import React, { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton, TextField } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import api from '../../../utils/axiosInstance';
import { LayoutQuestion } from '../LayoutQuestion';

import styles from '../../Form/Form.module.css';
export default function SelectionQuestion(props) {
  const [uploadError, setUploadError] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [fileContent, setFileContent] = useState(null);
  const [internalQuestionId] = useState(() => crypto.randomUUID());
  const currentFile = props.selectedFileSelectQuestion?.[internalQuestionId];

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    props.setIsUploadingFile(true);

    try {
      const response = await api.post('validateExcelQuestion', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      props.setSelectedFileSelectQuestion((prev) => ({
        ...prev,
        [internalQuestionId]: file,
      }));

      props.setInformation((prev) => ({
        ...prev,
        customOptions: response.data.filas,
        file: file,
      }));

      setUploadSuccess('Archivo válido ✅');
      setUploadError('');
      setFileContent(null);

      props.setErrorMessage((prev) => ({
        ...prev,
        selectedFileSelectQuestionError: false,
      }));

      props.setHelperText((prev) => ({
        ...prev,
        selectedFileSelectQuestionHelpertext: '',
      }));
    } catch (err) {
      setFileContent(null);

      setUploadSuccess('');
      setUploadError(
        err.response?.data?.message || 'Ocurrió un error al validar el archivo'
      );

      const reader = new FileReader();
      reader.onload = function (e) {
        setFileContent(e.target.result);
      };
      reader.readAsText(file);
    } finally {
      props.setIsUploadingFile(false); // ✅ Siempre se desactiva después de la carga
    }
  };

  const handleRemoveFile = () => {
    props.setSelectedFileSelectQuestion((prev) => {
      const updated = { ...prev };
      delete updated[internalQuestionId];
      return updated;
    });
    props.setInformation((prev) => ({
    ...prev,
    customOptions: Array(2).fill(''),  
    file: null,                        
  }));

    setUploadSuccess('');
    setUploadError('');
    setFileContent(null);
  };

  return (
    <LayoutQuestion {...props}>

      <div className={styles.input} style={{ marginTop: '1rem' }}>
        {!currentFile && (
          <label htmlFor={`excel-upload-${props.questionId}`}>
            <input
              accept=".xlsx"
              id={`excel-upload-${props.questionId}`}
              type="file"
              hidden
              onChange={handleFileUpload}
            />
            <Button
              variant="outlined"
              component="span"
              color={
                props.errorMessage.selectedFileSelectQuestionError
                  ? 'error'
                  : 'primary'
              }
              sx={{
                borderColor: props.errorMessage.selectedFileSelectQuestionError
                  ? 'red'
                  : undefined,
              }}
            >
              Subir archivo Excel
            </Button>
            {props.errorMessage.selectedFileSelectQuestionError && (
              <p style={{ color: 'red', marginTop: '0.3rem' }}>
                {props.helperText.selectedFileSelectQuestionHelpertext}
              </p>
            )}
          </label>
        )}

        {currentFile && (
          <div
            style={{
              marginTop: '0.5rem',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span style={{ marginRight: '1rem', color: '#333' }}>
              Archivo: <strong>{currentFile.name}</strong>
            </span>
            <IconButton size="small" onClick={handleRemoveFile}>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
        {props.isUploadingFile && (
          <p style={{ color: '#888', marginTop: '0.5rem' }}>
            Procesando archivo...
          </p>
        )}
        {uploadError && (
          <p style={{ color: 'red', marginTop: '0.5rem' }}>{uploadError}</p>
        )}
        {uploadSuccess && (
          <p style={{ color: 'green', marginTop: '0.5rem' }}>{uploadSuccess}</p>
        )}

        {/* Select para límite de opciones - SIEMPRE VISIBLE */}
        <div className={styles.input} style={{ marginTop: '1rem' }}>
          <TextField
            select
            label="Límite de opciones"
            value={props.information.haveLimit ? 'limited' : 'unlimited'}
            name="haveLimit"
            onChange={(e) => {
              const isLimited = e.target.value === 'limited';
              props.handleInformation({
                target: {
                  name: 'haveLimit',
                  value: isLimited,
                },
              });
              // Si cambia a ilimitado, limpiamos el valor del límite
              if (!isLimited) {
                props.handleInformation({
                  target: {
                    name: 'limitOptions',
                    value: 0,
                  },
                });
              }
            }}
            fullWidth
            size="small"
            helperText="¿Deseas limitar la cantidad de opciones seleccionables?"
          >
            <MenuItem value="unlimited">Ilimitado</MenuItem>
            <MenuItem value="limited">Con límite de opciones</MenuItem>
          </TextField>
        </div>

        {/* Input para límite de opciones (solo si eligió "limited") */}
        {props.information.haveLimit && (
          <div className={styles.input} style={{ marginTop: '0.5rem' }}>
            <TextField
              id="options-limit"
              label="Límite de opciones"
              type="number"
              value={props.information.limitOptions || ''}
              name="limitOptions"
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                let finalValue = value;

                if (isNaN(value) || value < 1) {
                  finalValue = 1;
                } else if (value > 10) {
                  finalValue = 10;
                }

                props.handleInformation({
                  target: {
                    name: 'limitOptions',
                    value: finalValue,
                  },
                });
              }}
              inputProps={{
                min: 1,
                max: 10,
              }}
              error={props.errorMessage.limitOptions}
              helperText={
                props.helperText.limitOptions ||
                'Mínimo: 1, Máximo: 10 opciones'
              }
              fullWidth
              size="small"
              placeholder="Ej: 5"
            />
          </div>
        )}
      </div>
    </LayoutQuestion>
  );
}
